import { RefObject, useEffect } from "react";

/**
 * react-slick keeps every slide in the DOM (including `.slick-cloned` copies).
 * `inert` removes inactive slides and their contents from the tab order.
 */
export const useNeutralizeInactiveSlides = (containerRef: RefObject<HTMLDivElement | null>) => {
  useEffect(() => {
    const root = containerRef.current;
    if (!root || typeof MutationObserver === "undefined") return;

    const sync = () => {
      root.querySelectorAll<HTMLElement>(".slick-slide").forEach((slide) => {
        slide.toggleAttribute("inert", !slide.classList.contains("slick-active"));
      });
    };

    sync();
    const observer = new MutationObserver(sync);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [containerRef]);
};
